module.exports = __webpack_public_path__ + "static/img/azb1.9f832a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/azb1.jpg
// module id = k7nl
// module chunks = 1